export default __webpack_public_path__ + "static/screenshot-6-8da82f9026a4273cfb178f6b119f077f.png";